import {DateTimePicker  as KendoDateTimePicker} from "@progress/kendo-react-dateinputs";
import KendoHOC from "./utils/KendoHOC";

const DateTimePicker = (options) => (KendoHOC(KendoDateTimePicker, options));

export default DateTimePicker;
